import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import './council.css';
// import ImageGallery, { GalleryImage } from '../carousel/ImageGallery';
import ImageSlider from '../ImageSlider/ImageSlider';

// const faith2025: GalleryImage[] = [
//   { src: '/assets/images/lenten2026/lenten2.jpeg', title: 'Annual Lenten Retreat 2026', alt: 'Annual Lenten Retreat 2026' },
//   { src: '/assets/images/lenten2026/lenten1.jpeg', title: 'Annual Lenten Retreat 2026', alt: 'Annual Lenten Retreat 2026' },
//   { src: '/assets/images/lenten2026/holyweek2026.jpeg', title: 'Holy Week 2026', alt: 'Holy Week 2026' },
// ];
// const holyweek2026: GalleryImage[] = [
//   { src: '/assets/images/lenten2026/holyweek2026.jpeg', title: 'Holy Week 2026', alt: 'Holy Week  2026' },
// ];
const sliderImages = [
  {
    src: '/assets/images/events3.jpeg',
    alt: 'Church worship service',
  },
  {
    src: '/assets/images/events1.jpeg',
    alt: 'Church gathering',
  },
];
const sliderImages2 = [
  {
    src: '/assets/images/IMG_3227.jpg',
    alt: 'Parish Fest 2026',
  },
  {
    src: '/assets/images/IMG_3228.jpg',
    alt: 'Parish Fest 2026',
  },
];

export default function Council() {
  return (
    <div className="container-fluid council-section">
      <div className="row my-5">
        <div className="col-12 col-md-4 text-center mb-4">
          <div className="card">
            <div className="card-header">
              MASS TIMINGS
            </div>
            <div className="card-body">
              <p className="card-text fw-bolder">SUNDAY - 5:00 PM</p>
              <p className="card-text fw-bolder">No Holy Mass on Mondays.</p>
              <p className="card-text fw-bolder">TUESDAY TO FRIDAY - 5:00 PM</p>
              <p className="card-text fw-bolder">SATURDAY - 9:00 AM(No Holy Mass on last Saturday)</p>
              <p className="card-text fw-bolder">SUNDAY CATECHISM - 3:30 PM</p>
              <p>Confession is available after every Holy Mass, except on Sundays.</p>
              <p className="text-center fw-bold">
                <a href="https://maps.app.goo.gl/xopB3p8rdAr5PJ4B6" target="_blank" rel="noreferrer" style={{ color: 'black', textDecoration: 'none' }}>
                  <LocationOnIcon style={{ fontWeight: 'bold', color: '#6D0000' }} />
                  6032 Normandy Drive, Halifax
                </a>
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 text-center mb-4">
          <div className="card">
            <div className="card-header">
              EVENTS
            </div>
            <div className="card-body">
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                <ImageSlider
                  images={sliderImages}
                  autoPlayInterval={5000}
                  height={400}
                />
              </div>
              {/* <p className="text-center fw-bolder mt-3">
                <CalendarMonthIcon style={{ fontWeight: 'bold', color: '#6D0000' }} />
                Gloria 2025 - On December 27
              </p> */}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 text-center mb-4">
          <div className="card">
            <div className="card-header">
              LATEST NEWS
            </div>
            <div className="card-body">
              <ImageSlider
                images={sliderImages2}
                autoPlayInterval={5000}
                height={400}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-3 text-center mb-4">
          <div
            style={{
              backgroundImage: 'url(/assets/images/popeLeo.png)',
              height: '364px',
              backgroundSize: 'cover',
              backgroundPosition: 'center top',
              backgroundRepeat: 'no-repeat',
              width: '100%',
            }}
          />
          <h5 className="mt-3 fw-bold">Pope Leo XIV</h5>
          <p>Pope Leo XIV is the head of the Catholic Church and sovereign of the Vatican City State. He is the first pope to have been born in the United States and North America .The second from the Americas</p>
        </div>
        <div className="col-12 col-md-3 text-center mb-4">
          <div
            style={{
              backgroundImage: 'url(/assets/images/MarRaphelThattil.png)',
              height: '364px',
              backgroundSize: 'cover',
              backgroundPosition: 'center top',
              backgroundRepeat: 'no-repeat',
              width: '100%',
            }}
          />
          <h5 className="mt-3 fw-bold">Mar Raphael Thattil</h5>
          <p>An Indian prelate of the Catholic Church. Mar Raphael Thattil  ,is the current Major Archbishop of the Syro-Malabar Catholic Church. It’s head quarters is in Kakkanad, Kerala, </p>
        </div>
        <div className="col-12 col-md-3 text-center mb-4">
          <div
            style={{
              backgroundImage: 'url(/assets/images/jose-kallu-1.jpeg)',
              height: '364px',
              backgroundSize: 'cover',
              backgroundPosition: 'center top',
              backgroundRepeat: 'no-repeat',
              width: '100%',
            }}
          />
          <h5 className="mt-3 fw-bold">Mar Jose Kalluvelil</h5>
          <p>Father Jose Kalluvelil has been serving the Syro Malabar Community in Toronto Canada since 2013. He was ordained bishop for the Syro-Malabar Eparchy of Mississauga, Canada on 19th September 2015.</p>
        </div>
        <div className="col-12 col-md-3 text-center mb-4">
          <div
            style={{
              backgroundImage: 'url(/assets/images/fr-daris2.jpg)',
              height: '364px',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              width: '100%',
            }}
          />
          <h5 className="mt-3 fw-bold">Fr. Daris Cherian</h5>
          <p>Pastor Holy Family Parish Halifax</p>
        </div>
        <div className="col-12 col-md-3 text-center mb-4">
          <div
            style={{
              backgroundImage: 'url(/assets/images/franklin-trustee.jpeg)',
              height: '364px',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              width: '100%',
            }}
          />
          <h5 className="mt-3 fw-bold">Franklin Francis</h5>
          <p>Parish Trustee</p>
        </div>
        <div className="col-12 col-md-3 text-center mb-4">
          <div
            style={{
              backgroundImage: 'url(/assets/images/jithinj.jpeg)',
              height: '364px',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              width: '100%',
            }}
          />
          <h5 className="mt-3 fw-bold">Jithin Joseph</h5>
          <p>Parish Trustee</p>
        </div>
      </div>
    </div>
  );
}
